import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <main>
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-primary to-secondary text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
          <div className="text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              Building Innovative Software Solutions
            </h1>
            <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto">
              At Skepa, we create cutting-edge technologies that push the boundaries of what's possible in software development.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <Link to="/projects" className="bg-accent text-dark px-8 py-3 rounded-lg font-semibold hover:bg-yellow-400 transition duration-300">
                View Our Projects
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-dark mb-4">About Skepa</h2>
            <p className="text-lg text-secondary max-w-2xl mx-auto">
              We're a passionate team of developers dedicated to creating software that matters. From programming languages to databases, we build tools that empower developers worldwide.
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="bg-primary text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-dark mb-2">Innovation</h3>
              <p className="text-secondary">We constantly explore new technologies and methodologies to stay ahead of the curve.</p>
            </div>
            <div className="text-center">
              <div className="bg-primary text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 2L3 7v11a1 1 0 001 1h12a1 1 0 001-1V7l-7-5z" clipRule="evenodd" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-dark mb-2">Quality</h3>
              <p className="text-secondary">Every project we undertake is built with attention to detail and rigorous testing.</p>
            </div>
            <div className="text-center">
              <div className="bg-primary text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-dark mb-2">Community</h3>
              <p className="text-secondary">We believe in open-source and fostering a supportive developer community.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Projects Preview */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-dark mb-4">Our Projects</h2>
            <p className="text-lg text-secondary">Explore our flagship products that are shaping the future of software development.</p>
          </div>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white rounded-lg shadow-lg overflow-hidden">
              <img src="/assets/skepalang.png" alt="Skepa-Lang" className="w-full aspect-square object-cover" />
              <div className="p-6">
                <h3 className="text-xl font-semibold text-dark mb-2">Skepa-Lang</h3>
                <p className="text-secondary mb-4">A modern programming language designed for simplicity and performance.</p>
                <Link to="/project/skepa-lang" className="text-primary hover:text-secondary font-semibold">Learn More →</Link>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-lg overflow-hidden">
              <img src="/assets/skepadb.png" alt="Skepa-DB" className="w-full aspect-square object-cover" />
              <div className="p-6">
                <h3 className="text-xl font-semibold text-dark mb-2">Skepa-DB</h3>
                <p className="text-secondary mb-4">A high-performance database solution for modern applications.</p>
                <Link to="/project/skepa-db" className="text-primary hover:text-secondary font-semibold">Learn More →</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-primary text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Ready to Innovate?</h2>
          <p className="text-xl mb-8">Join us in building the next generation of software solutions.</p>
          <Link to="/projects" className="bg-accent text-dark px-8 py-3 rounded-lg font-semibold hover:bg-yellow-400 transition duration-300">
            Get Started
          </Link>
        </div>
      </section>
    </main>
  );
};

export default Home;
